import { authApi } from '../api/authApi'
import { useAuthStore } from '../store/authStore'

export async function refreshAuthToken(): Promise<void> {
  const { refreshToken, setTokens, logout } = useAuthStore.getState()

  if (!refreshToken) {
    throw new Error('No refresh token available')
  }

  try {
    const response = await authApi.refreshToken(refreshToken)

    // Only update tokens and expireAt, don't update the entire user object
    // This prevents triggering re-renders in components that depend on user
    setTokens(
      response.data.accessToken,
      response.data.refreshToken,
      response.data.expiresAt,
      response.data.user, // Pass user only to update expireAt
    )

    console.log('Token refreshed successfully')
  } catch (error) {
    console.error('Token refresh failed:', error)
    logout()
    throw error
  }
}
